module.exports = __webpack_public_path__ + "img/arrow.31fbf43e.svg";